import * as $ from 'jquery';
import * as kendo from 'kendo/kendo.core';
import FavoriteVoyagesRepository from 'visuris/Data/Repositories/FavoriteVoyagesRepository';
// Imports without variable
import 'kendo/kendo.data';

export function create(options?: kendo.data.DataSourceOptions): kendo.data.DataSource {
    var repository = new FavoriteVoyagesRepository();
    var dataSourceOptions = {
        transport: {
            read: (kendoOptions: kendo.data.DataSourceTransportReadOptions) => {
                var retrieveFavoriteVoyages = repository.list();
                retrieveFavoriteVoyages.then(links => {
                    kendoOptions.success(links);
                });

                retrieveFavoriteVoyages.catch(e => {
                    kendoOptions.error(e);
                });
            }
        },
        pageSize: 20,
    };

    return new kendo.data.DataSource($.extend(dataSourceOptions, options));
}